const material_terms_uischema = {
    view: "main",
    title: "Material Terms of Employment",
    entity: "Material_Terms",
    linkBack: {
        name: 'Back to Profiles',
        link: '/dashboard/profiles',
    },
    button: {
        name: 'New Material Terms of Employment',
        style: 'default',
    }
}

export default material_terms_uischema;